export { MappedNoteCard } from './components/mapped-card';
export { NoteCard } from './components/card';
export type { NoteCardProps } from './types';

export const CardPriority = {
  Unset: 0,
  Lowest: 1,
  Lower: 2,
  Low: 3,
  Medium: 4,
  High: 5,
  Highest: 6,
} as const;
export type CardPriority = (typeof CardPriority)[keyof typeof CardPriority];
